<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog building_work"
    title="建物"
    top="5vh"
    width="900px"
    :visible.sync="visible"
    append-to-body
    @close="close"
  >
    <div class="flex_start flex_center_align mb6">
      <div class="split_line"></div>
      <span class="box_title">建物情報</span>
    </div>
    <div class="sure_box top_info mtn mb12">
      <vab-row class="row_box">
        <vab-col :span="4" class="title_box">建物</vab-col>
        <vab-col :span="20" class="word_box">
          <div class="flex_space flex_center_align">
            <div class="flex_auto line_height">
              {{ getFieldValue('blgsrnnm', dataList) }}
            </div>
            <div class="sub_title">
              （建物CD：{{ getFieldValue('buildingCd', dataList) }}）
            </div>
          </div>
        </vab-col>
      </vab-row>
      <vab-row class="row_box">
        <vab-col :span="4" class="title_box">住所</vab-col>
        <vab-col :span="20" class="word_box">
          <div class="flex_space flex_center_align">
            <div class="flex_auto line_height">
              {{ getFieldValue('adr1', dataList) }}
              {{ getFieldValue('adr2', dataList) }}
            </div>
          </div>
        </vab-col>
      </vab-row>
      <vab-row class="row_box">
        <vab-col :span="4" class="title_box">郵便番号</vab-col>
        <vab-col :span="8" class="word_box">
          <div class="flex_space flex_center_align">
            <div class="flex_auto line_height">
              {{ getFieldValue('postno', dataList) }}
            </div>
          </div>
        </vab-col>
        <vab-col :span="4" class="title_box">管理事務室電話番号</vab-col>
        <vab-col :span="8" class="word_box">
          <div class="flex_space flex_center_align">
            <div class="flex_auto line_height">
              {{ getFieldValue('mgotel', dataList) }}
            </div>
          </div>
        </vab-col>
      </vab-row>
      <vab-row class="row_box">
        <vab-col :span="4" class="title_box">担当部門</vab-col>
        <vab-col :span="8" class="word_box">
          <div class="flex_space flex_center_align">
            <div class="flex_auto line_height">
              {{ getFieldValue('orgkj', dataList) }}
            </div>
            <div class="sub_title">
              （部門CD：{{ getFieldValue('pstsctcd', dataList) }}）
            </div>
          </div>
        </vab-col>
        <vab-col :span="4" class="title_box">担当者</vab-col>
        <vab-col :span="8" class="word_box">
          <div class="flex_space flex_center_align">
            <div class="flex_auto line_height">
              {{ getFieldValue('chrnm', dataList) }}
            </div>
            <div class="sub_title">
              （担当者CD：{{ getFieldValue('chempcd', dataList) }}）
            </div>
          </div>
        </vab-col>
      </vab-row>
      <vab-row class="row_box">
        <vab-col :span="4" class="title_box">キーボックスパスワード</vab-col>
        <vab-col :span="20" class="word_box">
          <div class="flex_space flex_center_align">
            {{ getFieldValue('exBuildingKeyboxModel.passcode', dataList) }}
          </div>
        </vab-col>
      </vab-row>
    </div>
    <div class="flex_start flex_center_align mb6">
      <div class="split_line"></div>
      <span class="box_title">FM勤務情報</span>
    </div>
    <div class="sure_box top_info mtn">
      <vab-row class="row_box">
        <vab-col :span="12" class="table_header br">氏名</vab-col>
        <vab-col :span="12" class="table_header">勤務日／勤務時間</vab-col>
      </vab-row>
      <template v-if="dataList.fmWorkTimes.length > 0">
        <vab-row
          v-for="(itm, idx) in dataList.fmWorkTimes"
          :key="idx"
          class="row_box"
        >
          <vab-col :span="12" class="word_box8 br flex_center_align">
            {{ getFieldValue('empnmkj', itm) }}
          </vab-col>
          <vab-col :span="12" class="word_box8 br flex_center_align">
            {{ getFieldValue('knmfrdow', itm) }}
            {{ getFieldValue('knmfrdow', itm) ? '/' : '' }}
            {{ getFieldValue('knmstrtm', itm) | timeChange }}
            {{ itm.knmstrtm === '' ? '' : '~' }}
            {{ getFieldValue('knmendtm', itm) | timeChange }}
          </vab-col>
        </vab-row>
      </template>
      <template v-else>
        <vab-row>
          <vab-col :span="24" class="word_box8 br flex_center_align text_set">
            {{ $t(`validateMessage.${$messageCode.E00000104.name}`) }}
          </vab-col>
        </vab-row>
      </template>
    </div>
    <div slot="footer" class="flex_end">
      <div class="flex_start flex_center_align">
        <vab-button :btn-list="btnList" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Buildings',
    data() {
      return {
        visible: false,
        dataList: {
          fmWorkTimes: [],
        },
        btnList: [
          {
            name: '閉じる',
            type: 'plain',
            defaultColor: '#848484',
            hover: '#A1A1A1',
            bgColor: '#A1A1A1',
            hidden: false,
            click: () => {
              this.visible = false
            },
          },
        ],
      }
    },
    methods: {
      close() {
        this.dialogVisible = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .title_header {
    font-weight: 500;
    font-size: 12px;
    color: #848484;
  }

  .text_set {
    justify-content: center;
    font-size: 12px;
    border-right: none;
    color: rgba(0, 0, 0, 0.65);
  }
</style>
